import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Stylesheet
import "./ButtonGroup.scss";

export default class ButtonGroup extends PureComponent {
  static propTypes = {
    className: PropTypes.any,
    children: (props, key, componentName) => {
      React.Children.forEach(props.children, (child) => {
        const { type } = child;

        if (type.name !== "Button") {
          return new Error(
            `Invalid child component ${type.name} supplied to Grid. Must be one of these components: Button`
          );
        }

        return null;
      });
    },
    layout: PropTypes.oneOf(["inline", "stacked"]),
  };

  static defaultProps = {
    layout: "inline",
  };

  render() {
    const { className, ...rest } = this.props;

    const classes = classNames(
      "button_group",
      className,
      `is_${this.props.layout}`
    );

    return (
      <div className={classes} {...rest}>
        {this.props.children}
      </div>
    );
  }
}
